document.addEventListener('DOMContentLoaded', () => {
  const accordionBtn = document.querySelector('.donation-accordion-btn');
  const accordionContent = document.querySelector('.donation-accordion-content');

  if (accordionBtn && accordionContent) {
    accordionBtn.addEventListener('click', () => {
      const isExpanded = accordionBtn.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        accordionBtn.setAttribute('aria-expanded', 'false');
      } else {
        accordionBtn.setAttribute('aria-expanded', 'true');
      }
    });
  }
});
